<script setup lang="ts">
import {formatTime} from "../utils/FormatUtils.ts";
import {computed, onBeforeUnmount} from "vue";
import componentStore from "../store.ts";
import {storeToRefs} from "pinia";
import useStore from "../store.ts";
const {
  id,
  style,
  locale,
} = defineProps({
  id: String,
  style: Object,
  locale: String,
  src: String,
  font: String
})

const { currentDate } = storeToRefs(useStore());
let dateInterval = -1;
onBeforeUnmount(() => clearInterval(dateInterval));
const store = componentStore()
const component = store.components[id!];
let format = component.text_props.format;

const clockProps = component.digital_clock_props ?? {};
const timeZone = computed(() => clockProps.time_zone);
const timeZoneOffset = computed(() => clockProps.time_zone ? undefined : clockProps.time_zone_offset_minutes);
const effectiveLocale = computed(() => clockProps.locale ?? locale);

const width = computed(() => style!.width)
const height = computed(() => style!.height)

const getFormattedTime = () => formatTime(
    new Date(currentDate.value),
    format,
    3,
    effectiveLocale.value,
    {
      timeZone: timeZone.value,
      offsetMinutes: timeZoneOffset.value
    }
);

if (component.digital_clock_props?.time_separator_blink) {
  dateInterval = window.setInterval(() => {
    const idx = Math.floor(new Date().getTime() / 1000) % 2;
    if (idx) {
      format = format.replace(":", " ");
    }else {
      format = format.replace(" ", ":");
    }
  }, 1000);
}


</script>

<template>
  <div :id="`${id}`" :style="{...style, width, height}">
    <div :style="{height: 'min-content', position: 'relative', paddingRight: '2px',  font: font }" :class="`text-${id}`">
       {{ getFormattedTime() }}
    </div>
    <slot>

    </slot>
  </div>

</template>

<style scoped>

</style>